/** Format first-response seconds like Reports Overview: Xm Ys / Xs / — */
export function formatFirstResponseTime(seconds: number): string {
  if (seconds <= 0) return '—'
  if (seconds >= 60) {
    return `${Math.floor(seconds / 60)}m ${Math.round(seconds % 60)}s`
  }
  return `${Math.round(seconds)}s`
}
